import { render, staticRenderFns } from "./EditRelease.vue?vue&type=template&id=0a45fa76"
import script from "./EditRelease.vue?vue&type=script&lang=ts"
export * from "./EditRelease.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports